import { GoogleButton } from '@perch-labs/shrike';
import styled from 'styled-components';

export const GoogleSignUpButton = styled(GoogleButton)`
  p {
    width: auto;
  }
`;
